import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageBoxImageDialogComponent } from './message-box-image/message-box-image-dialog.component';

type MessageBoxColor = 'warning_outlined' | 'warning' | 'info' | 'info_background' | 'success' | 'error' | 'message';

@Component({
    selector: 'syn-message-box',
    templateUrl: 'message-box.component.html',
    styleUrls: ['message-box.component.scss']
})
export class MessageBoxComponent implements OnInit {

    @Input() mainText: string;
    @Input() subText?: string;
    @Input() leftIcon?: string;
    @Input() rightIcon?: string;
    @Input() letter?: string;
    @Input() image?: string;
    @Input() textAlign = 'left';
    @Input() color?: MessageBoxColor;
    @Input() translations?: { [key: string]: string } = { 'CLOSE': 'Fermer'};
    @Input() noMarginTop = false;

    public backgroundColor: string;
    public textColor: string;
    public iconColor: string;
    public borderRadius = 5;
    public hasBorder = true;

    constructor(
        private matDialog: MatDialog
    ) {}

    public ngOnInit(): void {
        if (this.letter && this.letter.length > 1) {
            this.letter = this.letter[0];
        }
        switch (this.color) {
            case 'info':
                this.backgroundColor = '#ffffff';
                this.textColor = '#2196f3';
                this.iconColor = '#1070BD';
                break;
            case 'info_background':
                this.backgroundColor = '#e3f2fd';
                this.textColor = '#1565c0';
                this.iconColor = '#1565c0';
                this.hasBorder = false;
                break;
            case 'success':
                this.backgroundColor = '#ffffff';
                this.textColor = '#4caf50';
                this.iconColor = '#4caf50';
                break;
            case 'warning':
                this.backgroundColor = '#ef6c00';
                this.textColor = '#ffffff';
                this.iconColor = '#ffffff';
                break;
            case 'warning_outlined':
                this.backgroundColor = '#ffffff';
                this.textColor = '#ef6c00';
                this.iconColor = '#ef6c00';
                break;
            case 'error':
                this.backgroundColor = '#e53935';
                this.textColor = '#ffffff';
                this.iconColor = '#ffffff';
                break;
            case 'message':
            default:
                this.backgroundColor = '#383d41';
                this.textColor = '#e0e0e0';
                this.iconColor = '#e0e0e0';
        }
    }

    public fullscreen() {
        this.matDialog.open(MessageBoxImageDialogComponent, {
            data: {
                image: this.image,
                translations: this.translations
            }
        });
    }
}
